import { mapGetters, mapState } from "vuex"

const profile_utilities = {
    methods: {
        can (permission, record) {
            const profile = this.profile
            if(!profile) return false
            if(this.is_db_admin_active || (profile.role === this.$root.constants.roles.DEVELOPER.id)) return true
            if(permission.match(/^(firm|(prospective_)?project|contact)\.delete$/)) return (profile.role === this.$root.constants.roles.BIZ_MANAGER.id)
            if(permission.match(/^user\.(create|delete|roles)$/)) return false
            if(permission.match(/^user\.view/)) return true
            if(permission.match(/^import\./)) return (profile.role >= this.$root.constants.roles.ADMIN.id)
            if(permission.match(/^project_request\./)) return (profile.role === this.$root.constants.roles.PRINCIPAL.id) || (profile.role === this.$root.constants.roles.ASSOCIATE_PRINCIPAL.id) || (profile.role === this.$root.constants.roles.ADMIN.id)

            return true
        },
        can_or_db_admin (condition) {
            return condition || this.is_db_admin_active
        },
        is_role (role, profile = null) {
            if(!profile) profile = this.profile
            if(!profile) return false
            return profile.role === role
        },
        user_benefits (selectable) {
            if(selectable) {
                return [
                    { id: "vacation_hours", label: "Vacation Time" },
                    { id: "professional_development_hours", label: "Professional Dev. Time" },
                    { id: "full_day_outage", label: "Business Out of Office" }
                ]
            }
            const benefits = [
                { id: "vacation_hours", label: "Vacation Time" },
                { id: "professional_development_hours", label: "Professional Dev. Time" },
                { id: "business_development", label: "Business Dev. Time" },
                { id: "sick_hours", label: "Sick Time" },
                { id: "days_of_service", label: "Day of Service" },
                { id: "parental_leave_hours", label: "Parental Leave" },
                // {id: "holiday_hours", label: "Holiday Time"},
                { id: "bereavement_hours", label: "Bereavement Time" }, // added to all: https://bitbucket.org/MacPrawn/lam-partners/issues/889/time-off-dropdown
                { id: "full_day_outage", label: "Full Day Outage" }
            ]

            return benefits
        },
        working_hours (working_weeks, start_date, end_date) {
            let hours = 0
            if(working_weeks) {
                const current_date = this.$moment(start_date).startOf("isoWeek")
                // end_date = end_date.endOf('week')
                while(current_date.isSameOrBefore(end_date)) {
                    const current_date_string = current_date.format("YYYY-MM-DD")
                    if(working_weeks[current_date_string]) hours += working_weeks[current_date_string] || 0
                    current_date.add(1, "weeks")
                }
            }
            return hours
        },
        off_days (user, start_date, end_date) {
            let nb_off_days = 0

            if(user && user.time_off) {
                start_date = this.$moment(start_date).startOf("day")
                end_date = this.$moment(end_date).endOf("day")

                user.time_off.forEach(off_period => {
                    if(off_period.approved) {
                        const off_start = this.$moment(off_period.starts_at).startOf("day")
                        const off_end = this.$moment(off_period.ends_at).endOf("day")
                        if(off_start.isSameOrBefore(end_date) && off_end.isSameOrAfter(start_date)) {
                            const range_start = this.$moment.max(start_date, off_start)
                            const range_end = this.$moment.min(end_date, off_end)
                            nb_off_days += this.$moment().isoWeekdayCalc(range_start, range_end, [1, 2, 3, 4, 5])
                        }
                    }
                })
            }

            return nb_off_days
        }
    },
    computed: {
        ...mapState(["profile_id"]),
        ...mapGetters(["entity_records"]),
        raw_user_records () {
            return this.entity_records("user").filter(user => {
                return !user.deleted_at
            })
        },
        roles () {
            return Object.values(this.$root.constants.roles)
        },
        user () {
            return Object.values(this.raw_user_records)
        },
        profile () {
            return this.raw_user_records.find(user => user.id === this.profile_id) || {}
        },
        is_designer () {
            return this.is_role(this.$root.constants.roles.DESIGNER.id)
        },
        is_lighting_designer () {
            return this.is_role(this.$root.constants.roles.LIGHTING_DESIGNER.id)
        },
        is_senior_lighting_designer () {
            return this.is_role(this.$root.constants.roles.SENIOR_LIGHTING_DESIGNER.id)
        },
        is_some_designer () {
            return this.is_designer || this.is_lighting_designer || this.is_senior_lighting_designer
        },
        is_associate () {
            return this.is_role(this.$root.constants.roles.ASSOCIATE.id)
        },
        is_senior_associate () {
            return this.is_role(this.$root.constants.roles.SENIOR_ASSOCIATE.id)
        },
        is_associate_principal () {
            return this.is_role(this.$root.constants.roles.ASSOCIATE_PRINCIPAL.id)
        },
        is_principal () {
            return this.is_role(this.$root.constants.roles.PRINCIPAL.id)
        },
        is_business_manager () {
            return this.is_role(this.$root.constants.roles.BIZ_MANAGER.id)
        },
        is_administrator () {
            return this.is_role(this.$root.constants.roles.ADMIN.id)
        },
        is_settings_admin () {
            const profile = this.profile
            return !!profile && !!profile.is_settings_admin
        },
        is_db_admin_active () {
            const profile = this.profile
            return !!profile && !!profile.is_db_admin_active
        },
        is_developer () {
            return this.is_role(this.$root.constants.roles.DEVELOPER.id)
        },
        user_stipends () {
            return [
                { id: "professional_development_stipend", label: "Professional Dev. Stipend", monetary: true },
                { id: "membership_stipend", label: "Memberships Stipend", monetary: true }
                // {id: "medical_stipend", label: "Medical Stipend", monetary: true},
            ]
        }
    }
}

export default profile_utilities
